// extracted by mini-css-extract-plugin
module.exports = {"starsRatingWrapper":"DisplayRating-module--starsRatingWrapper--2_aqv","ratingResult":"DisplayRating-module--ratingResult--3KQ9S"};